module.exports = __webpack_public_path__ + "img/Truce_Logo_White_Indigo_Road.58b57808.png";